// Switch — on/off toggle backed by a native checkbox. Green track when on.

import { forwardRef, type InputHTMLAttributes } from 'react';

export type SwitchSize = 'sm' | 'md' | 'lg';

/* Omit native `size` (a number for text inputs, meaningless here) so our variant prop owns the name. */
export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string;
  /** Track size: 'sm' 2.5×1.5rem, 'md' (default) 3×1.75rem, 'lg' 3.5×2rem. */
  size?: SwitchSize;
}

const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, className = '', size = 'md', disabled, ...rest },
  ref,
) {
  const classes = ['app-switch', `app-switch--${size}`, disabled && 'is-disabled', className]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={classes}>
      <input
        ref={ref}
        type='checkbox'
        role='switch'
        className='app-switch__input'
        disabled={disabled}
        {...rest}
      />
      <span className='app-switch__track' aria-hidden='true'>
        <span className='app-switch__knob' />
      </span>
      {label && <span className='app-switch__label'>{label}</span>}
    </label>
  );
});

export default Switch;
